import { getCalibrationLevel } from 'libs/end-to-end/src/calibration-level';
import React from 'react';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { OverviewGauge } from 'apps/sigma2-ui/src/components/overview/OverviewGauge';
import { replaceTextColor } from 'apps/sigma2-ui/src/components/ui/Typography';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { CalibrationFraming } from 'libs/end-to-end/src/calibration-framing';
import { getCalibrationLevelUIDetails } from 'libs/end-to-end/src/ui';

export const TalentCalibrationScoreCard = (props: {
  calibrationScore: number;
  passedTestsCount: number;
  totalTestsCount: number;
  calibrationFraming: CalibrationFraming;
}) => {
  const {
    calibrationScore,
    passedTestsCount,
    totalTestsCount,
    calibrationFraming,
  } = props;

  const language = useLanguage();
  const calibrationLevel = getCalibrationLevel(calibrationScore);
  const optimizationUiDetails =
    getCalibrationLevelUIDetails(calibrationFraming)[calibrationLevel];

  const testPassedPercentage = Math.min(1.0, calibrationScore / 6);

  return (
    <div className="flex flex-col gap-4 items-start p-5 min-h-[18rem] bg-white rounded-lg">
      <S2Typography
        variant={'headline-5-alt'}
        translatedContent={language.talentCalibration({ calibrationFraming })}
      />
      <div className="self-center">
        <OverviewGauge
          fillColor={optimizationUiDetails.hexColor}
          percentage={testPassedPercentage}
          content={
            <div className="flex flex-col items-center -mt-24 space-y-2">
              {optimizationUiDetails.longerText && (
                <S2Typography
                  variant="headline-5-alt"
                  translatedContent={language[
                    optimizationUiDetails.descriptionMessageId
                  ]()}
                  dangerouslyOverrideClassNameFn={replaceTextColor(
                    optimizationUiDetails.textColor,
                  )}
                />
              )}
              {!optimizationUiDetails.longerText && (
                <S2Typography
                  variant="headline-4-alt"
                  translatedContent={language[
                    optimizationUiDetails.descriptionMessageId
                  ]()}
                  dangerouslyOverrideClassNameFn={replaceTextColor(
                    optimizationUiDetails.textColor,
                  )}
                />
              )}

              <p className="font-sans font-bold text-xs text-gray-800">
                <span>
                  {passedTestsCount}/{totalTestsCount}
                </span>
              </p>

              <p className="font-sans text-xs text-[#696D70] text-center capitalize">
                {language.testsPassed()}
              </p>
            </div>
          }
        />
      </div>
    </div>
  );
};
